import LoadMoreButton, { useLoadMore } from '@/components/buttons/LoadMoreButton'
import { ImgFallback } from '@/components/Image'
import { AppLayout } from '@/components/Layouts/AppLayout'
import { useLanguage, useLayout } from '@/hooks/Contexts'
import { API_URL } from '@/utils/Consts'
import { appUtils } from 'lib/AppUtils'
import { FC, Fragment, memo, useEffect } from 'react'
import useSWRImmutable from 'swr/immutable'

export default function CharityDonations() {
  const {
    errors: { no_data },
  } = useLanguage()
  const { isDesktop } = useLayout()

  const { pageIndex, total, setTotal, list, setList, loadMore } = useLoadMore()

  const { data, isValidating, isLoading } = useSWRImmutable(
    typeof isDesktop == 'undefined' ? null : `${API_URL.donations}?perPage=${isDesktop === false ? '12' : '18'}&page=${pageIndex + 1}`,
    appUtils.fetcher
  )

  useEffect(() => {
    if (!isValidating && !isLoading && data?.data?.length > 0) {
      setList(prev => data?.data?.reduce?.((arr, item) => arr.concat(item), prev))
      setTotal(data?.total)
    }
  }, [isValidating, isLoading, data])

  return (
    <AppLayout title='charity' outerCls='uppercase' innerCls='grid w-full animate-fade-in-down grid-cols-2 gap-2 md:gap-4 lg:grid-cols-3 lg:gap-6'>
      {list?.length > 0 ? list.map((item: Record<string, any>, index: number) => <Item key={'row-' + index} data={item} />) : null}

      {isValidating || isLoading ? (
        <Skeletons />
      ) : data?.data?.length > 0 ? null : (
        <div className='col-span-full row-span-full animate-fade-in-down place-self-center py-24 text-center'>{no_data}</div>
      )}

      <LoadMoreButton className='col-span-full h-10 justify-self-center' onClick={loadMore} current={list?.length} total={total} />
    </AppLayout>
  )
}

const Item: FC<{ data: Record<any, any> }> = ({ data }) => {
  return (
    <div className='card-container col-span-1 flex flex-col pb-4 text-sm !shadow-stone-300 md:text-base'>
      <ImgFallback src={data.image_url} className='h-auto max-h-72 w-full rounded-t object-contain' alt={data.title || data.image_url} />
      <div className='px-4 pt-2 shadow-[0_-8px_15px_-3px_#d6d3d1]'>
        <p className='font-semibold'>{data.title}</p>
        <span className='text-sm text-black'>{data.description}</span>
      </div>
    </div>
  )
}

const Skeletons: FC<{ numOfItems?: number }> = memo(function Skeleton({ numOfItems = 12 }) {
  const skeletons = []
  for (let index = 0; index < numOfItems; index++) {
    skeletons.push(
      <div key={index} className='card-container animate-fade-in-down'>
        <div className='skeleton-wrap p-4'>
          <div className='skeleton-line h-4'></div>
          <div className='skeleton-line mt-4 h-3 w-1/2'></div>
          <div className='skeleton-line mt-4 h-3 w-1/2'></div>
          <div className='skeleton-line mt-8 h-3 w-1/2'></div>
        </div>
      </div>
    )
  }
  return <Fragment>{skeletons}</Fragment>
})
